import React from 'react';
import { Box, Theme, Typography } from '@mui/material';

import paragonLogo from '../../../resources/ParagonLogo.png';

const FloatingPoweredByParagon = () => (
  <Box
    sx={{
      display: { xs: 'none', md: 'block' },
      minWidth: 100,
      p: 2,
      textAlign: 'left',

      userSelect: 'none',
      zIndex: (theme: Theme) => theme.zIndex.drawer - 1,
    }}
  >
    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <Typography variant="caption" sx={{ marginRight: '6px' }}>
        Powered by
      </Typography>
      <img src={paragonLogo} alt="Paragon" width={100} />
    </Box>
  </Box>
);

export default FloatingPoweredByParagon;
